import React, { useEffect, useState } from "react";
import { Navbar, Nav, Offcanvas, Button, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/Sidebar.css";
import { Link, useLocation } from "react-router";
import { BsJustify } from "react-icons/bs";
import config from "../../config/config";

const Sidebar = ({ special, clearModalData }) => {
  const [show, setShow] = useState(false);
  const [activeCard, setActiveCard] = useState(() => {
    // Retrieve the saved active card index from localStorage or default to 0
    return Number(localStorage.getItem("activeCard")) || 1;
  });
  console.log(activeCard);

  const handleCardClick = (index) => {
    setActiveCard(index); // Update the active card state
    localStorage.setItem("activeCard", index); // Save to localStorage
  };
  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };
  console.log(activeCard);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const data = [
    {
      id: 1,
      link: "dashboard",
      title: "Dashboard",
      icon: "assets/images/dashboard/icon/dashboard.svg",
    },
    {
      id: 2,
      link: "project",
      title: "All Projects",
      icon: "assets/images/dashboard/icon/swap.svg",
    },
  ];

  return (
    <div className="bshadow">
      <ScrollToTop />
      {/* Sidebar Toggle Button */}
      <div
        variant="light"
        onClick={handleShow}
        className="d-lg-none"
        style={{
          position: "absolute",
          top: "32px",
          left: "15px",
          width: "100px",
          cursor: "pointer",
          zIndex: 1000,
        }}
      >
        ☰ <span>Menu</span>
      </div>

      {/* Sidebar for larger screens */}
      <nav
        className="sidebar d-none d-lg-flex flex-column"
        style={{
          padding: "15px 15px 15px 15px",
        }}
      >
        <Link to={`${config.baseUrl}`} className="mb-4">
          <img
            src="assets/images/logo/logo.png"
            style={{ width: 224, height: 53 }}
            alt=""
          />
        </Link>
        <Nav className="flex-column gap-4" style={{ fontSize: "1.1rem" }}>
          {data.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                requestAnimationFrame(() => handleCardClick(item.id));
              }}
            >
              <Link
                to={`${config.baseUrl}${item.link}`}
                className={`sidebar-tab dash-gradient py-3 px-4 ${
                  activeCard === item.id ? "active" : ""
                }`}
              >
                <img src={item.icon} alt="" className="me-2" height={`20px`} width={`20px`} /> {item.title}
              </Link>
            </div>
          ))}
        </Nav>
        {special && (
          <div className="mt-4" style={{ bottom: "15%" }}>
            <div onClick={() => handleCardClick(5)}>
              <Link
                to={`${config.baseUrl}referral`}
                className={`sidebar-tab dash-gradient py-3 px-4 ${
                  activeCard === 5 ? "active" : ""
                }`}
                style={{ fontSize: "1.1rem" }}
              >
                <img src="images/logout.svg" alt="" className="me-2" /> Referral
              </Link>
            </div>
          </div>
        )}
        <footer className="position-absolute mb-0 start-0 end-0 w-100" style={{ bottom: "0%" }}>
          <div className="px-2 pb-2">
            <small className="text-light-grey x-small">
              Unitronix © 2025. All Rights Reserved.
            </small>
          </div>
          <div className="footer-menu">
            <a href="#" className="text-light-grey text-decoration-none x-small">
              Terms & Condition
            </a>
            <span className="px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="5"
                height="4"
                viewBox="0 0 5 4"
                fill="none"
              >
                <circle cx="2.5" cy="2" r="2" fill="white" fill-opacity="0.5" />
              </svg>
            </span>
            <a href="#" className="text-light-grey text-decoration-none x-small">
              Privacy Policy
            </a>
            <span className="px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="5"
                height="4"
                viewBox="0 0 5 4"
                fill="none"
              >
                <circle cx="2.5" cy="2" r="2" fill="white" fill-opacity="0.5" />
              </svg>
            </span>
            <a href="#" className="text-light-grey text-decoration-none x-small">
              FAQ
            </a>
          </div>
        </footer>
      </nav>

      {/* Offcanvas Sidebar for smaller screens */}
      <div style={{ position: "relative" }}>
        <Offcanvas
          show={show}
          onHide={handleClose}
          className="d-lg-none slide-animation"
          style={{
            backgroundColor: "#01053D",
            color: "#fff",
            height: "100vh",
            display: "flex",
            position: "absolute",
            borderRadius: "0px 10px 10px 0px",
            overflow: "auto",
          }}
        >
          <Offcanvas.Header closeButton>
            <Link to={`${config.baseUrl}dashboard`}>
              <img
                src="assets/images/logo/logo.png"
                style={{ width: 224, height: 53 }}
                alt=""
              />
            </Link>
          </Offcanvas.Header>
          <Offcanvas.Body className="">
            {data.map((item, index) => (
              <div
                key={index}
                style={{ minWidth: 200 }}
                onClick={() =>
                  requestAnimationFrame(() => handleCardClick(index))
                }
              >
                <Nav
                  className="flex-column gap-3 mt-4"
                  style={{ fontSize: "1.1rem" }}
                >
                  <Link
                    to={`${config.baseUrl}${item.link}`}
                    onClick={handleClose}
                    className={`sidebar-tab dash-gradient py-4 px-4 ${
                      activeCard === index ? "active" : ""
                    }`}
                  >
                    <img src={item.icon} alt="" className="me-2" /> {item.title}
                  </Link>
                </Nav>
              </div>
            ))}
            {special && (
              <div className="mt-4" style={{ bottom: "15%" }}>
                <div style={{ minWidth: 200 }}>
                  <Link
                    to={`${config.baseUrl}referral`}
                    className={`sidebar-tab dash-gradient py-3 px-4 ${
                      activeCard === 5 ? "active" : ""
                    }`}
                    style={{ fontSize: "1.1rem" }}
                  >
                    <img src="images/logout.svg" alt="" className="me-2" />{" "}
                    Referral
                  </Link>
                </div>
              </div>
            )}
            <div style={{ minWidth: 200 }}>
              <Nav
                className="flex-column gap-3 mt-4"
                style={{ fontSize: "1.1rem" }}
              >
                <span>Unitronix © 2025. All Rights Reserved.</span>
              </Nav>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </div>
  );
};

export default Sidebar;
